const postServiceTypes = {
  toastr: 'Tipo de Serviço adicionado',
  toastr1: ' foi adicionado com sucesso',
  toastrError: 'Tipo de Serviço já cadastrado',
  toastrError1: 'Insira outro nome'
}

export default postServiceTypes;
